import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Folder } from '@novaheal/types';
import { axios } from 'utils/axios';
import { CONTENTFUL_IS_PREVIEW } from 'config/env';

export const getFolderById = async (id: string): Promise<Folder> => {
  const { data: folder } = await axios.get<Folder>(
    `/gql/folder/${id}?preview=${CONTENTFUL_IS_PREVIEW}`
  );

  return folder;
};

export const useFolders = (id: string): UseQueryResult<Folder, unknown> => {
  return useQuery({
    queryKey: [`folder-${id}`],
    queryFn: () => getFolderById(id),
  });
};
